export type AppointmentColors = {
  color?: string
  background?: string
  borderColor?: string
}

/**
 * Applies an appointment's status/category colours to its wrapper element.
 * Border uses !important so Syncfusion drag/selection styles (which set border: 0)
 * cannot wipe the status/category edge after a move.
 */
export const applyAppointmentColors = (
  element: HTMLElement,
  { color, background, borderColor }: AppointmentColors,
): void => {
  element.style.color = color ?? ''
  element.style.background = background ?? ''
  element.style.setProperty('--appointment-border-color', borderColor ?? 'var(--light-03)')
  element.style.setProperty(
    'border',
    `4px solid ${borderColor ?? 'var(--light-03)'}`,
    'important',
  )
}
